var map = {
	"./avatar-fase2-ct1.mp4": 9565,
	"./avatar-fase2-ct2.mp4": 3626,
	"./avatar-fase2-ct3.mp4": 5220,
	"./presentacion-caso-sc1-intro.mp4": 5133,
	"./presentacion-caso-sc2-intro.mp4": 5706,
	"./santiago-daurella-rull.mp4": 3076,
	"./video-sc2-ct2.mp4": 263,
	"./video-sc3-ct1.mp4": 1191,
	"./video-sc3-ct2.mp4": 886,
	"./video-sc4-ct2.mp4": 5925,
	"./video-sc4-ct3.mp4": 6640,
	"./video-sc5-ct2.mp4": 369,
	"./video-sc5-fin.mp4": 4635,
	"./video-sc5-intro.mp4": 5355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1812;